module.exports = __webpack_public_path__ + "img/cutscene-placeholder.30ded6bd.png";